/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 is a good default for checksums and integrity. SHA-1 is included for legacy compatibility but is no longer considered collision-resistant for security.`)
};

const es_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 es una buena opción predeterminada para checksums e integridad. SHA-1 se incluye para compatibilidad heredada pero ya no se considera resistente a colisiones para seguridad.`)
};

const de_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 ist eine gute Standardeinstellung für checksums und Integrität. SHA-1 wird aus Gründen der Abwärtskompatibilität beibehalten, wird aber nicht mehr als kollisionsresistent für Sicherheit angesehen.`)
};

const nl_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 is een goede standaard voor controlesommen en integriteit. SHA-1 is opgenomen voor verouderde compatibiliteit, maar wordt niet langer als botsingsbestendig voor beveiliging beschouwd.`)
};

const fr_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 est un bon choix par défaut pour les checksums et l'intégrité. SHA-1 est inclus pour la compatibilité avec les systèmes existants mais n'est plus considéré comme résistant aux collisions pour la sécurité.`)
};

const it_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 è una buona impostazione predefinita per checksum e integrità. SHA-1 è incluso per compatibilità legacy ma non è più considerato resistente alle collisioni per la sicurezza.`)
};

const pt_br2_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 é um bom padrão para checksums e integridade. SHA-1 é incluído para compatibilidade com sistemas legados, mas não é mais considerado resistente a colisões para segurança.`)
};

const pt_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 é uma boa predefinição para checksums e integridade. SHA-1 está incluído para compatibilidade legada mas já não é considerado resistente a colisões para segurança.`)
};

const ja_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256はチェックサムと整合性に良いデフォルトです。SHA-1はレガシー互換性のために含まれていますが、セキュリティについて衝突耐性があるとは見なされなくなりました。`)
};

const zh_hg_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于 checksum 校验和完整性检查，SHA-256 是不错的默认选择。SHA-1 的加入是为了兼容旧系统，但在安全性上已不再被视为具有抗碰撞能力。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq2_a", locale)
	if (locale === "en") return en_hg_faq2_a(inputs)
	if (locale === "es") return es_hg_faq2_a(inputs)
	if (locale === "de") return de_hg_faq2_a(inputs)
	if (locale === "nl") return nl_hg_faq2_a(inputs)
	if (locale === "fr") return fr_hg_faq2_a(inputs)
	if (locale === "it") return it_hg_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq2_a(inputs)
	if (locale === "pt") return pt_hg_faq2_a(inputs)
	if (locale === "ja") return ja_hg_faq2_a(inputs)
	return zh_hg_faq2_a(inputs)
};